import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiParameters } from 'src/app/configs/api.params';

@Injectable({ providedIn: 'root' })
export class ResetPasswordService {
    INIT_VALUE = null;

    constructor(
        private http: HttpClient,
    ) { }

    /**
     * Reset password token generation request that calls API route
     * @param email - is user email that he entered
     * @returns - response to check status
     */
    generateToken(email: string) {
        return this.http.post(`${apiParameters.url}/changePassword`, { email })
    }

    /**
     * Reset password token checking request that calls API route
     * @param token - is reset password token that is provided by generateToken(email)
     * @returns - response to check status
     */
    checkToken(token: string) {
        return this.http.get(`${apiParameters.url}/changePassword/${token}`)
    }

    /**
     * Change password method that calls API route
     * @param password - is user password that he entered
     * @param token - is reset password token that is provided by generateToken(email)
     * @returns - response to check status
     */
    changePassword(password: string, token: string) {
        return this.http.post(`${apiParameters.url}/changePassword/${token}`, { password })
    }
}
